
import XInput from 'vux/src/components/x-input/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
name: 'regist',
data () {
return {
disabled: true,
email: '', // 邮箱
oldpassword: '',
newpassword: '', // 密码
cpassword: '',
pwdType: 'password',
eyeType: 'ios-circle-outline'
}
},
methods: {
handleSubmit () {
if (!this.email || !this.newpassword) {
this.$vux.toast.text('您有未填项，不能注册')
} else {
let params = {
UserName: this.email,
OldPassword: this.oldpassword,
NewPassword: this.newpassword
}
let that = this
this.$api.changePassword(params).then(res => {
if (res.Status === 1) {
sessionStorage.removeItem('user')
that.$vux.toast.text('修改成功，跳转到登录页面！')
that.$router.push({ path: '/mobile' })
} else {
that.$vux.alert.show({
title: '错误',
content: res.Message
})
}
}).catch(function (res) {
that.$vux.alert.show({
title: '错误',
content: '网络错误！'
})
})
}
},
checkPassword (value) {
const passwordReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/ 
if (!value) {
return { valid: false, msg: '请设置密码' }
}
if (passwordReg.test(value)) {
return { valid: true }
} else {
return { valid: false, msg: '密码须包含数字、字母两种元素，且密码位数为6-16位' }
}
},
checkcPassword (value) {
if (!value) {
return { valid: false, msg: '请设置密码' }
}
if (this.newpassword === value) {
return { valid: true }
} else {
return { valid: false, msg: '两次密码输入不一致！' }
}
},
keyDown () {
if (this.$refs.refemail.valid === true &&
this.$refs.refnewpassword.valid === true &&
this.$refs.refoldpassword.valid === true &&
this.$refs.refcpassword.valid === true) {
this.disabled = false
} else {
this.disabled = true
}
},
showPassword () {
if (this.pwdType === 'password') {
this.pwdType = ''
this.eyeType = 'ios-circle-filled'
} else {
this.pwdType = 'password'
this.eyeType = 'ios-circle-outline'
}
}
},
created () {
window.document.title = '修改密码'
},
mounted: function () {
let user = sessionStorage.getItem('user')
if (user) {
this.email = user
}
},
components: {
XInput,
XButton,
Group,
Box,
XSwitch,
XHeader
}
}



// WEBPACK FOOTER //
// ./src/mobile/modifypassword.vue